"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtistTopHeader = ArtistTopHeader;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
/** elの祖先を辿り、overflow-yがauto/scrollな最初の要素(=実際のスクロールコンテナ)を返す */
function findScrollableAncestor(el) {
    var _a;
    var node = (_a = el === null || el === void 0 ? void 0 : el.parentElement) !== null && _a !== void 0 ? _a : null;
    while (node) {
        var overflowY = getComputedStyle(node).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll')
            return node;
        node = node.parentElement;
    }
    return null;
}
/**
 * セーフエリア (ノッチ) 分の帯。高さは env(safe-area-inset-top)。
 * Web では 0 (帯なし)、モバイルではノッチ分の余白として機能する。
 * 背景はヘッダー本体から継承する (透明 / スクロール時ガラス)。
 */
function StatusBar() {
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            height: 'env(safe-area-inset-top, 0px)',
            flexShrink: 0,
        } }));
}
/** ArtistTop v2 専用ナビバー。AppHeaderからArtistTop固有要件(ハンバーガーメニュー・ヒーロー画像への重畳等)を分離したもの */
function ArtistTopHeader(_a) {
    var title = _a.title, left = _a.left, right = _a.right, _b = _a.showBackground, showBackground = _b === void 0 ? false : _b, _c = _a.titleAlign, titleAlign = _c === void 0 ? 'center' : _c, _d = _a.overlapNext, overlapNext = _d === void 0 ? false : _d, _e = _a.hideTitleWhenAtTop, hideTitleWhenAtTop = _e === void 0 ? false : _e, maxWidth = _a.maxWidth;
    var p = (0, theme_1.useV2Palette)();
    var rootRef = (0, react_1.useRef)(null);
    // findScrollableAncestorの再走査を避けるため、マウント時に1度だけ計算してキャッシュする
    var scrollParentRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        scrollParentRef.current = findScrollableAncestor(rootRef.current);
    }, []);
    // fixed化でヘッダーがスクロールコンテナの外に浮くため、ホイール操作が自動で伝わらない。祖先のスクロールコンテナを探して手動で転送する
    var handleWheel = function (e) {
        var _a;
        (_a = scrollParentRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({ top: e.deltaY, left: e.deltaX });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { ref: rootRef, onWheel: handleWheel, sx: {
                    // 内側スクロールコンテナのオーバースクロール中にstickyがずれる不具合があったため、ビューポート基準で完全固定されるfixedにしている
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: function (theme) { return theme.zIndex.appBar; },
                    width: '100%',
                    maxWidth: maxWidth,
                    mx: 'auto',
                    // 背景表示時のみガラス面。非表示時は透明で背後を見せる。
                    backgroundColor: showBackground
                        ? p.background.surface
                        : 'transparent',
                    backdropFilter: showBackground ? 'blur(16px)' : 'none',
                    WebkitBackdropFilter: showBackground ? 'blur(16px)' : 'none',
                    boxShadow: showBackground
                        ? "inset 0 -1px 0 0 ".concat(p.border.neutral.default)
                        : 'none',
                    transition: 'background-color 0.2s ease, box-shadow 0.2s ease, backdrop-filter 0.2s ease',
                }, children: [(0, jsx_runtime_1.jsx)(StatusBar, {}), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", sx: { height: 56, px: "".concat(tokens_1.spacing.sm, "px") }, children: [left && (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { mr: "".concat(tokens_1.spacing.xs, "px") }, children: left }), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                    flexGrow: 1,
                                    fontSize: tokens_1.fontSize.base,
                                    fontWeight: tokens_1.fontWeight.semiBold,
                                    lineHeight: "".concat(tokens_1.lineHeight.base, "px"),
                                    color: showBackground
                                        ? p.foreground.neutral.primary
                                        : p.foreground.neutral.white,
                                    textAlign: titleAlign,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    opacity: hideTitleWhenAtTop && !showBackground ? 0 : 1,
                                    transition: 'color 0.2s ease, opacity 0.2s ease',
                                }, children: title }), right] })] }), !overlapNext && ((0, jsx_runtime_1.jsx)(material_1.Box, { "aria-hidden": true, sx: { height: 'calc(56px + env(safe-area-inset-top, 0px))' } }))] }));
}
